import React from 'react'
import { isPollEndingSoon, Poll } from '@/tumeloshared'
import { DaysRemaining } from './DaysRemaining'
import { VoteNow } from './VoteNow'

interface Props {
  poll: Poll
}

export const OpenPoll: React.FC<Props> = ({ poll }) => {
  const isEndingSoon = isPollEndingSoon(poll)

  if (isEndingSoon) {
    return <DaysRemaining poll={poll} showVoteCount />
  }

  return <VoteNow poll={poll} showVoteCount />
}
